import { ClaimRecordStatus } from '@typesApp/ClaimRecord'
import { FormValues } from '@typesApp/InsuranceForm'
import { ProviderType } from '@typesApp/Insurer'
import { DateUtil } from '@utils/dateUtil'
import { DeepPartialSkipArrayKey } from 'react-hook-form/dist/types'

const KEY_INSURANCE_FORM_STATE = 'direct-billing.insurance-form'

type FormState = {
  formFields: FormValues
  providerType?: ProviderType
}

export const setLocalFormState = (
  formFields: DeepPartialSkipArrayKey<FormValues>,
  dateFormat: string,
  providerType?: ProviderType
) => {
  if (formFields?.claimData?.patient?.dateOfBirth) {
    const parsedDate = DateUtil.parse(formFields.claimData.patient.dateOfBirth, dateFormat)
    formFields.claimData.patient.dateOfBirth = DateUtil.toISODate(parsedDate)
  }

  // remove empty policyNumber or memberId fields
  const insuree = formFields?.claimData?.primaryCoverage?.insuree
  if (insuree) {
    if (!insuree.policyNumber) delete insuree.policyNumber
    if (!insuree.memberId) delete insuree.memberId
  }
  if (insuree && Object.keys(insuree).length === 0) {
    delete formFields?.claimData?.primaryCoverage?.insuree
  }

  const localState = {
    formFields,
    providerType,
  }

  try {
    sessionStorage.setItem(KEY_INSURANCE_FORM_STATE, JSON.stringify(localState))
  } catch (e) {
    console.error(e)
  }
}

export const getLocalFormState = (): FormState | null => {
  try {
    const formState = sessionStorage.getItem(KEY_INSURANCE_FORM_STATE)
    if (formState) {
      const parsedFormState: FormState = JSON.parse(formState)
      return parsedFormState
    }
    return null
  } catch (e) {
    console.error(e)
    return null
  }
}

export const clearLocalFormState = () => {
  sessionStorage.removeItem(KEY_INSURANCE_FORM_STATE)
}
